(function() {
  "use strict";
  angular.module("marketPlace.content", []);
})();
